export default __webpack_public_path__ + "media/images/icons/icon_cached-bb4d475764c7c6fe4ffc1e3496af21fb.svg";